module.exports = __webpack_public_path__ + "dist/media/ec_comp_text_field.3bc1f8d8.svg";